'use strict';
var sug = '';
window.actionTrackings = window.actionTrackings || [];
/**
 * @author: Mateusz Czaja
 * @date 13.08.2007
 */
function SearchForm($) {
    //global, what was last used (important, if anybody press enter on suggest)
    var gLastField;

    //object of suggest
    var suggObj;

    //object of calendar
    var calObj;

    //fields
    var fields1 = ['dep', 'dest', 'depDate', 'destDate'];

    //divs
    var fields2 = ['sugdep', 'sugdest', 'cal1', 'cal2'];
    var holders = [
        'depSugHolder',
        'destSugHolder',
        'depCalHolder',
        'destCalHolder',
    ];
    var gObjectName = 'sf';
    this.name = gObjectName;
    var mouseButtonDown = false;
    var opt = {
        destEmptyClass: 'initialEmpty',
        form: '#suche, #carRequestData',
    };

    var hasLoaded = false;

    function init(cal, disableAutofocus, descriptionHeadline) {
        disableAutofocus = !!disableAutofocus || false;
        cal.descriptionHeadline = !!descriptionHeadline || false;

        calObj = cal;
        calObj.init();

        var $depInput = $('#depInput');
        var $backCity = $('#backCity');
        var $showOnlyAtAirport = $('#showOnlyAtAirport');
        var $inputPlane = $('.input-plane');

        var $showOnlyCityRail = $(opt.form).find(
            'input[name=showOnlyCityRail]'
        );
        if (!$showOnlyCityRail.length) {
            $showOnlyCityRail = $('<input/>', {
                type: 'checkbox',
                style: 'display: none',
                name: 'showOnlyCityRail',
                value: 'yes',
            }).appendTo($(opt.form));
        }

        var $showOnlyRail = $(opt.form).find('input[name=showOnlyRail]');
        if (!$showOnlyRail.length) {
            $showOnlyRail = $('<input/>', {
                type: 'checkbox',
                style: 'display: none',
                name: 'showOnlyRail',
                value: 'yes',
            }).appendTo($(opt.form));
        }

        if (
            $depInput.hasClass('error') ||
            (stj && stj.global && stj.global.isSerp())
        ) {
            disableAutofocus = true;
        }

        hasLoaded = true;

        $('<div id="suggest-error-dep" class="field-error box-round-tiny" />')
            .html('<p>' + js_tr.suggest['error-dep'] + '</p><i></i>')
            .appendTo('#depInput');
        if (
            $depInput.find('.field-error').length > 1 &&
            $('#invalid_dep').length > 0
        ) {
            $('#suggest-error-dep')
                .parent()
                .find('.field-error')
                .not('#suggest-error-dep')
                .hide();
        } else if ($depInput.find('.field-error').length > 1) {
            $('#suggest-error-dep').hide();
        }

        $('<div id="suggest-error-dest" class="field-error box-round-tiny" />')
            .html('<p>' + js_tr.suggest['error-dest'] + '</p><i></i>')
            .appendTo('#backCity');
        if ($backCity.find('.field-error').length > 1) {
            $('#suggest-error-dest').hide();
        }

        if ($backCity.is(':visible')) {
            $('#suggest-error-dest').hide();
        }
        $('<div id="suggest-hint-dep" class="suggest-hint" />')
            .append('<i id="info-icon" class="flt-lft" />')
            .append(
                '&nbsp;<span class="dsp-ibk pdg-top-3">' +
                    js_tr.suggest['hint-dep'] +
                    '</span>'
            )
            .appendTo('body');

        $('<div id="suggest-hint-unknown-city" class="suggest-hint" />')
            .append('<i id="info-icon" class="flt-lft" />')
            .append(
                '<p class="dsp-ibk pdg-top-3">' +
                    js_tr.suggest['hint-unknown-city'] +
                    '</p>'
            )
            .appendTo('body');

        calObj.setCaller(this);
        listenBody();
        listenFocusBlur();
        try {
            if (!disableAutofocus) {
                document.getElementById('dep').trigger('focus');
            }
        } catch (e) {}

        $(window).on('resize', function () {
            setHolderDivs();
        });

        $('#dep, #dest').on('change', function () {
            handleLocationChange(this.id);
        });

        $('#booking-information .filter, #findCancel').on('click', function () {
            $('#booking-information').toggle();
            $('#carRequestData').toggle();
        });

        $('.carRequestLocationToggle').on('click', function () {
            var $wrapper = $('.carRequestLocation');
            var sameLocationClass = 'carRequestLocationSame';
            if ($wrapper.hasClass(sameLocationClass)) {
                setTimeout(function () {
                    $('#dest').trigger('focus');
                }, 100);
                $('#dest').val('');
                $wrapper.removeClass(sameLocationClass);
            } else {
                $wrapper.addClass(sameLocationClass);
                $('#dep').trigger('focus');
                $('#dest').val($('#dep').val());
                $('#destAirport').val($('#depAirport').val());
                handleLocationChange('dest');
            }
        });

        $(document)
            .on('mousedown', function () {
                mouseButtonDown = true;
            })
            .on('mouseup', function () {
                mouseButtonDown = false;
            });

        $('#jsAvailable').val(1);

        if ($('#isTablet').val() === '1') {
            if (false === $('#suggest-error-dep').is(':visible')) {
                document.getElementById('find').focus();

                $('#dep, #dest').on('focus', function () {
                    var $self = $(this);
                    $('html,body').animate(
                        {
                            scrollTop: $self.offset().top - 45,
                        },
                        5
                    );
                });
            }
        }
    }

    this.init = init;

    function getHasLoaded() {
        return hasLoaded;
    }

    this.getHasLoaded = getHasLoaded;

    function replace() {
        setHolderDivs();
    }

    this.replace = replace;

    function listenBody() {
        $('body').off().off('keyup', processKey).on('keyup', processKey);
    }

    this.listenBody = listenBody;

    function listenFocusBlur() {
        var fields1Length = fields1.length;
        for (var i = 0; i < fields1Length; ++i) {
            var $elm = $('#' + fields1[i]);
            $elm.off('focus click', processFocus)
                .on('focus click', processFocus)
                .on('blur', processBlur);
        }

        $('#depDateP label, #destDateP label, #depDateCaller, #destDateCaller')
            .off('click', processCal)
            .on('click', processCal);
    }

    this.listenFocusBlur = listenFocusBlur;

    function processKey(event) {
        var id = event.target ? event.target.id : event.srcElement.id;
        if (id === 'find') {
            id = gLastField;
        }

        if (id === 'dep' || id === 'dest') {
            processSuggest(event, id);
        } else if (id === 'depDate' || id === 'destDate') {
            processDate(event);
        }

        if (id) {
            hideDivs(event);
        }
    }

    function handleLocationChange(field) {
        switch (field) {
            case 'dep':
                $('#orgDepAirport').val('');
                $('#orgDestAirport').val('');
                break;

            case 'dest':
                $('#orgDestAirport').val('');
                break;

            default:
                // nothing
                break;
        }
    }

    function processFocus(event) {
        var id = event.target ? event.target.id : event.srcElement.id;
        if (id) {
            gLastField = id;
        } else {
            id = gLastField;
        }

        setHolderDivs(id);

        if (mouseButtonDown) {
            $('#' + id).addClass('focusclicked');
        }

        if (id === 'dep' || id === 'dest') {
            processSuggest(event, id);
        } else {
            toggleElement(id, event.type === 'focus');
        }

        if (event.type === 'click') {
            $('#' + id).removeClass('focusclicked');
        }
    }

    function toggleElement(id, forceShow) {
        setHolderDivs(id);
        hideDivs(null, id);

        var divID = '',
            fields1Length = fields1.length;

        for (var i = 0; i < fields1Length; ++i) {
            if (fields1[i] === id) {
                divID = fields2[i];
                break;
            }
        }

        var $field = $('#' + divID);

        if (id === 'depDate' || id === 'destDate') {
            if (forceShow || $field.css('visibility') === 'hidden') {
                calObj.showCal(id, divID);
            } else if (!$('#' + id).hasClass('focusclicked')) {
                document.getElementById('find').focus();
                $field.css('visibility', 'hidden');
            }
        }
    }

    this.toggleElement = toggleElement;

    function processBlur(event) {
        var id = event.target ? event.target.id : event.srcElement.id;

        if (id === 'depDate' || id === 'destDate') {
            calObj.parseDataField(id);
        }

        document.getElementById('submitEnabled').value = 1;
    }

    function processSuggest(event, id) {
        if (!suggObj) {
            return;
        }

        var idd = event.target ? event.target.id : event.srcElement.id;

        if (idd === id) {
            suggObj.processKey(event);
        } else {
            //for IE, after enter
            suggObj.fill(-1, id);
            gotoNext(id);
        }
    } //F:processSuggest

    function processDate(event) {
        if (event.keyCode !== 9 && event.keyCode !== 16) {
            hideDivs();
        }
    }

    function hideDivs(event, field) {
        var preventHidingOn = [
            '#cal1',
            '#cal2',
            '#depDateCaller',
            '#destDateCaller',
        ];
        var id = 0;
        if (event) {
            id = event.target ? event.target.id : event.srcElement.id;
        } else {
            if (field) {
                id = field;
            }
        }
        if (gLastField === 'sugdepTime' || gLastField === 'sugdestTime') {
            return;
        }

        if (id === 'callinkr' || id === 'callinkl') {
            return;
        }

        var preventHiding = false;
        if (event) {
            $.each(preventHidingOn, function (i, elm) {
                elm = $(elm).get(0);
                if (
                    elm &&
                    ($.contains(elm, event.target) || elm === event.target)
                ) {
                    preventHiding = true;
                }
            });
        }

        var fields1Length = fields1.length;
        for (var i = 0; i < fields1Length; ++i) {
            if (id !== fields1[i] && !preventHiding) {
                if (fields2[i].match(/sug/)) {
                    $('#' + fields2[i]).hide();
                } else {
                    $('#' + fields2[i]).css('visibility', 'hidden');
                }
            }
        }
    } //F:hideDivs
    this.hideDivs = hideDivs;

    //some browser after enter don't know where is focus
    function gotoNext(id) {
        var fields1Length = fields1.length;
        for (var i = 0; i < fields1Length; ++i) {
            if (fields1[i] === id && i + 1 < fields1Length) {
                hideDivs();
                return;
            }
        }

        document.getElementById('find').focus();
        hideDivs();
    } //F:gotoNext
    this.gotoNext = gotoNext;

    function checkForm() {
        var $depField = $('#dep');
        var $suggestHintDep = $('#suggest-hint-dep');

        var $submitButton = $('#find');

        if ($('#submitEnabled').val() === '1') {
            if (
                $('#countryOrState').val() === '1' &&
                $('#depAirport').val() === '' &&
                $depField.val().length > 3
            ) {
                var pos = $depField.offset();
                var mWidth = $suggestHintDep.outerWidth();
                var left = pos.left - mWidth - 5 + 'px';
                var top = pos.top - 4 + 'px';
                $suggestHintDep
                    .css({
                        left: left,
                        top: top,
                    })
                    .show();
                var leftArrow = $.Event('keydown');
                leftArrow.which = 39;
                $depField.trigger('focus').trigger(leftArrow);
                return false;
            }

            if (window.stj && stj.global) {
                stj.global.setCookie('chnl', stj.global.getOriginPage());
            }

            $(opt.form).trigger('search-submit');

            $('button.btn').addClass('load').find('i').html('T');

            // BM-68289 send tracking for affiliate with widget iframe here
            if (
                window.affiliateCampaignParams &&
                !window.affiliateCampaignParamsTracked
            ) {
                stj.analytics.trackCampaign(window.affiliateCampaignParams);
            }

            if (typeof stj.global !== 'undefined') {
                stj.global.trackCurrentFindClickTimestamp();
            }

            // will be reset after suggest selection
            $('#submitEnabled').val('0');
            return true;
        }
        return false;
    }

    this.checkForm = checkForm;

    function setHolderDivs() {
        var id = arguments[0];

        if (id) {
            coords.setXY('#' + id, '#' + holders[$.inArray(id, fields1)]);
        } else {
            $.each(fields1, function (i, id) {
                coords.setXY('#' + id, '#' + holders[i]);
            });
        }
    }

    function processCal() {
        var id =
            typeof $(this).attr('id') !== 'undefined'
                ? $(this).attr('id')
                : $(this).parent().attr('id');

        if (id.match(/dep/)) {
            toggleElement('depDate');
        } else {
            toggleElement('destDate');
        }
        return false;
    }

    function showResults() {
        document.getElementById('noResults').style.display = 'none';
        document.getElementById('autoNoResults').style.opacity = 1;
    }

    this.showResults = showResults;

    function trackSearchEventToGoogle() {
        $('#suche, #find').on('search-submit', function () {
            var searchString = $('#dep').val();
            var isSuggestSearch = $('#depAirport').val();
            window.actionTrackings.push({
                acTrAc: 'searched_destination',
                acTrLa: searchString,
                acTrVa: isSuggestSearch ? 1 : 0,
            });

            var labelIndex = null,
                labelOutput = null;
            if ($('#airport_pickup').length) {
                // certain airport selected
                labelIndex = 'sug_airport_' + $('#airport_pickup').val();
                labelOutput = 'airport_pickup_' + $('#airport_pickup').val();
            } else if ($('#showOnlyAtAirport:checkbox:checked').length) {
                // entry "all airports" selected
                labelIndex = 'sug_AllAirports';
                labelOutput = 'fib_onlyAtAirport';
            }

            if (null !== labelIndex) {
                window.actionTrackings.push({
                    acTrAc: 'Suggest',
                    acTrLa: labelIndex,
                });
            }

            if (null !== labelOutput) {
                window.actionTrackings.push({
                    acTrAc: 'Filter',
                    acTrLa: labelOutput,
                });
            }
        });
    }

    this.trackSearchEventToGoogle = trackSearchEventToGoogle;

    function clearField(field, clearInput) {
        if (field !== 'dep' && field !== 'dest') {
            throw new ReferenceError('field ' + field + ' not available');
        }

        if (clearInput) {
            $('#' + field).val('');
        }
        $('#' + field + 'States').val('');
        $('#' + field + 'Airport').val('');
        $('#' + field + 'Country').val('');
    }

    this.clearField = clearField;

    /* BM-42804 */
    /*
     this.winterWheelSeasons = {
     'DE': {'from': 1001, 'to': 331},
     'CH': {'from': 1001, 'to': 430},
     'EE': {'from': 1201, 'to': 331},
     'LV': {'from': 1201, 'to': 331},
     'LT': {'from': 1101, 'to': 401},
     'AT': {'from': 1101, 'to': 415},
     'IT': {'from': 1015, 'to': 415},
     'SI': {'from': 1115, 'to': 315},
     'SE': {'from': 1201, 'to': 229},
     'FI': {'from': 1201, 'to': 229},
     'CZ': {'from': 1015, 'to': 415},
     'HU': {'from': 1015, 'to': 415},
     'SK': {'from': 1015, 'to': 415},
     'UA': {'from': 1015, 'to': 415}
     }

     this.checkWinterWheelSeason = function (depMonth, depDay, countryCode) {
     var showWinterWheels = false;
     var winterWheelFilter = $('#fib_eb, label [for="fib_eb"]');
     if (this.winterWheelSeasons.hasOwnProperty(countryCode)) {
     var season = this.winterWheelSeasons[countryCode];
     var time = depMonth.toString() + depDay.toString();
     if (time >= season.from || time <= season.to) {
     showWinterWheels = true;
     }
     }
     if (showWinterWheels === true) {
     winterWheelFilter.show();
     } else {
     winterWheelFilter.hide();
     }
     }
     */
}
var sf = new SearchForm(jQuery);

jQuery(function ($) {
    var isMobile = $('#isMobile').val() === '1';
    var isTablet = $('#isTablet').val() === '1';
    var $backCitySelect = $('#backCitySelectC');
    var $youngDriverSelect = $('#youngDriverSelect');

    $('.best-cities a')
        .off()
        .on('click', function () {
            var $slide = $('.best-cities .slide');
            var $next = $(this).next();
            $slide.hide();
            if (!$next.attr('style').match('inline')) {
                $next.toggle();
            }
            return false;
        })
        .next()
        .hide();

    $('.top-cities .slide').hide();

    $('.top-cities')
        .on('mouseover', function () {
            $(this).find('.slide').show();
        })
        .on('mouseout', function () {
            $(this).find('.slide').hide();
        });

    $('.search-started').hide();

    var searchFormSubmit = $('#suche #find');
    var hasBmElement = $('.tuev-search-form-logo');
    var nonMobile = !isMobile && !isTablet;

    $('#destSelect').on('change', function () {
        if ($(this).is(':checked')) {
            $('#backCity').show();
            $backCitySelect.hide();
            if (nonMobile) {
                setTimeout(function () {
                    $('#dest').trigger('focus');
                }, 100);
                if (hasBmElement.length) {
                    searchFormSubmit.css({ marginTop: '1px' });
                }
            } else {
                document.getElementById('dest').trigger('focus');
            }
        } else {
            $('#backCity').hide().removeClass();
            $('suggest-error-dest').hide();
            $('#suche').off('submit');
            $('#suche-car').off('submit');
        }
        if (nonMobile) {
            sf.replace();
        }
        sf.clearField('dest', true);
    });

    var destinationInput = $('#dest');
    var departureInput = $('#dep');

    if (
        destinationInput.val() === '' ||
        destinationInput.val() === departureInput.val() ||
        destinationInput.val() === 'wie Abholort' ||
        destinationInput.val() === 'identique'
    ) {
        $backCitySelect.show();
        if (hasBmElement.length) {
            searchFormSubmit.css({ marginTop: '13px' });
        }
    } else {
        $backCitySelect.hide();
        if (hasBmElement.length) {
            searchFormSubmit.css({ marginTop: '1px' });
        }
    }

    $('#closeIcon').on('click', function () {
        $('#backCity').hide();
        $backCitySelect.show();
        $('#destSelect').prop('checked', false);
        if (hasBmElement.length) {
            searchFormSubmit.css({ marginTop: '13px' });
        }
    });

    $('#youngDriverC').on('change', function () {
        if (!$(this).is(':checked')) {
            $youngDriverSelect.hide();
            $('#youngDriver').show();

            if (hasBmElement.length) {
                searchFormSubmit.css({ marginTop: '1px' });
            }
        }
    });

    $('#youngDriverAge').on('change', function () {
        window.actionTrackings.push({
            acTrAc: 'YoungDriverAbTest',
            acTrLa: $(this).val(),
        });
    });

    if (!isMobile) {
        $('#dep').on('click', function () {
            sf.replace();
        });
    }
});
